export {
  extractFootnotes,
  PostFootnoteAnnotation,
  PostFootnotesSection,
} from "./PostFootnotes";
export type { Footnote } from "./PostFootnotes";
